// extracted by mini-css-extract-plugin
module.exports = {"ul":"styles_ul__8V1vZ","swiper-button-next":"styles_swiper-button-next__i_2ET","swiper-button-prev":"styles_swiper-button-prev__5dX7y"};